/**
 * Hands a File picked on the entry page ("+" attach, P6-01) to the Document Upload Portal.
 * Router state cannot carry a File, so it waits here for one navigation; `takePendingFile()`
 * returns it once and clears it.
 */
let pending = null;

export function setPendingFile(file) {
  pending = file || null;
}

export function takePendingFile() {
  const f = pending;
  pending = null;
  return f;
}
